import { OdataFilters, queryCollection } from "helpers/reqparams";
import { alertRequest, body, request } from "services/request";

const resource = "api/distributionBidSources";

const index = ({ preparedFilter, ...params }: OdataFilters) => {
    const query = queryCollection(params, { filter: { ...preparedFilter } });
    return request(`${resource}/getlist${query}`, { method: "GET" }, { countInHeaders: true });
};

const list = () => request(`${resource}/getlist`, { method: "GET" });

const apply = (params: {}) => alertRequest(`${resource}/apply`, body(params));

const editIcon = (params: {}) => alertRequest(`${resource}/editIcon`, params);

const clearIcon = (params: {}) => alertRequest(`${resource}/clearIcon`, body(params));

const delItem = (params: {}) => alertRequest(`${resource}/delete`, body(params));

export { apply, index, delItem, list, editIcon, clearIcon };
